var _mask, _path, _g, _g2, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 210,
    viewBox: "0 0 117 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_554_120",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3105 210L58.3105 210L58.3106 108L60.3106 108L60.3105 210Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.3105 210L61.3105 206.94L59.3105 206.94L59.3105 210L61.3105 210ZM61.3105 202.86L61.3105 196.74L59.3105 196.74L59.3105 202.86L61.3105 202.86ZM61.3105 192.66L61.3105 186.54L59.3105 186.54L59.3105 192.66L61.3105 192.66ZM61.3105 182.46L61.3105 176.34L59.3105 176.34L59.3105 182.46L61.3105 182.46ZM61.3106 172.26L61.3106 166.14L59.3106 166.14L59.3106 172.26L61.3106 172.26ZM61.3106 162.06L61.3106 155.94L59.3106 155.94L59.3106 162.06L61.3106 162.06ZM61.3106 151.86L61.3106 145.74L59.3106 145.74L59.3106 151.86L61.3106 151.86ZM61.3106 141.66L61.3106 135.54L59.3106 135.54L59.3106 141.66L61.3106 141.66ZM61.3106 131.46L61.3106 125.34L59.3106 125.34L59.3106 131.46L61.3106 131.46ZM61.3106 121.26L61.3106 115.14L59.3106 115.14L59.3106 121.26L61.3106 121.26ZM61.3106 111.06L61.3106 108L59.3106 108L59.3106 111.06L61.3106 111.06ZM62.3105 210L62.3105 206.94L58.3105 206.94L58.3105 210L62.3105 210ZM62.3105 202.86L62.3105 196.74L58.3105 196.74L58.3105 202.86L62.3105 202.86ZM62.3105 192.66L62.3105 186.54L58.3105 186.54L58.3105 192.66L62.3105 192.66ZM62.3105 182.46L62.3105 176.34L58.3105 176.34L58.3105 182.46L62.3105 182.46ZM62.3106 172.26L62.3106 166.14L58.3106 166.14L58.3106 172.26L62.3106 172.26ZM62.3106 162.06L62.3106 155.94L58.3106 155.94L58.3106 162.06L62.3106 162.06ZM62.3106 151.86L62.3106 145.74L58.3106 145.74L58.3106 151.86L62.3106 151.86ZM62.3106 141.66L62.3106 135.54L58.3106 135.54L58.3106 141.66L62.3106 141.66ZM62.3106 131.46L62.3106 125.34L58.3106 125.34L58.3106 131.46L62.3106 131.46ZM62.3106 121.26L62.3106 115.14L58.3106 115.14L58.3106 121.26L62.3106 121.26ZM62.3106 111.06L62.3106 108L58.3106 108L58.3106 111.06L62.3106 111.06Z",
    fill: "#777777",
    mask: "url(#path-1-inside-1_554_120)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_554_120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 105,
    height: 105,
    rx: 52.5,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_554_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.17 65.8651V72.0057C84.1642 72.9901 83.7715 73.9328 83.0766 74.6301C82.3816 75.3273 81.4403 75.7233 80.4559 75.7324H72.4375C71.4515 75.7223 70.5086 75.3267 69.8105 74.6302C69.1124 73.9337 68.7147 72.9917 68.7023 72.0057V65.8651C68.7184 64.8889 69.1204 63.9588 69.8203 63.2782C70.5203 62.5976 71.4613 62.2219 72.4375 62.2332H75.413V59.5559H59.4262V62.2332H62.6227C63.5809 62.2239 64.5037 62.5955 65.1882 63.2661C65.8727 63.9368 66.2629 64.8518 66.2732 65.81V72.0031C66.2818 72.981 65.9024 73.9223 65.2181 74.6209C64.5338 75.3195 63.6005 75.7183 62.6227 75.7299H54.5543C53.575 75.7172 52.6401 75.3187 51.9527 74.621C51.2653 73.9233 50.8808 72.9826 50.8827 72.0031V65.8625C50.8874 64.8977 51.2742 63.9741 51.9583 63.2939C52.6425 62.6137 53.5684 62.2323 54.5332 62.2332H57.3392V59.5559H41.7547V62.2332H44.7302C45.6962 62.2235 46.6268 62.5964 47.3187 63.2705C48.0106 63.9447 48.4076 64.8653 48.423 65.8312V72.0031C48.4231 72.9857 48.0351 73.9285 47.3435 74.6264C46.6519 75.3244 45.7127 75.7209 44.7302 75.7299H36.6838C35.7017 75.7229 34.7625 75.3266 34.0722 74.628C33.3819 73.9293 32.997 72.9853 33.002 72.0031V65.8625C33.0067 64.898 33.3933 63.9747 34.0771 63.2945C34.7609 62.6143 35.6863 62.2327 36.6508 62.2332H39.7101V57.4223H57.3401V53.8794H50.9995C49.2378 53.8794 47.3702 51.7484 47.3702 49.8139V40.0372C47.3702 38.0324 49.2336 37.0092 50.9995 37.0092H66.1707C66.5756 36.9729 66.9831 37.0392 67.3556 37.202C67.7281 37.3649 68.0535 37.619 68.3017 37.9409C68.7003 38.5768 68.8852 39.3235 68.8294 40.0719V49.863C68.8292 50.6298 68.6936 51.3905 68.4288 52.1101C68.2825 52.5981 67.9872 53.0281 67.5842 53.3398C67.1813 53.6514 66.6908 53.8292 66.1817 53.8481H59.3974V57.446H77.5228V62.2332H80.4661C81.4384 62.2187 82.3768 62.5904 83.0754 63.2668C83.774 63.9432 84.1759 64.8691 84.1928 65.8413C84.17 65.8439 84.17 65.854 84.17 65.8651Z",
    fill: "url(#paint0_linear_554_120)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.3105,
    y: 210,
    width: 22,
    height: 22,
    rx: 11,
    transform: "rotate(-180 70.3105 210)",
    fill: "#412A8E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_554_120",
    x: 0,
    y: 0,
    width: 117,
    height: 117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_554_120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_554_120",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_554_120",
    x1: 58.5974,
    y1: 36.9995,
    x2: 58.5974,
    y2: 75.7324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#412A8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#412A8E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_554_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.1908,
    height: 38.73,
    fill: "white",
    transform: "translate(33 37)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/Resources.6451e1bd63f5506d4560f64835d6ccaa.svg";
export { ForwardRef as ReactComponent };